define('services/common/ajax/OpenTrade',['app'], function (app) {
    app.factory('OpenTrade', ['$q','biAnalyticService','auiAjaxWithError',function ($q,biAnalyticService,auiAjaxWithError) {

        /**
         * bi 上报用户行为 打点记事件
         * @param api 接口名
         * @param options 调用接口的参数
         */
        function BI(api, options) {
            biAnalyticService.bianalytic(api, options);
        }


        /**
         * 调用公共ajax方法
         * @param options 调用接口的参数
         * @param getErrorCodeFunction 自己判断错误码的方法
         * @param isCustomError 使用自定义接口报错处理方法
         */
        function AJAX(options, isCustomError,api,timeout) {
            var defer = $q.defer();
            auiAjaxWithError.curry('OpenTrade',api)(options, isCustomError,timeout).then(function (data) {
                defer.resolve(data);
            }).catch(function (data) {
                defer.reject(data);
            });
            return defer.promise;
        }

        function errorAjax(options, isCustomError,api,timeout) {
            var defer = $q.defer();
            auiAjaxWithError.curryWithoutError('OpenTrade',api)(options, isCustomError,timeout).then(function (data) {
                defer.resolve(data);
            }).catch(function (data) {
                defer.reject(data);
            });
            return defer.promise;
        }


        // 错误码判断
        function getErrorCodeFunction(data){
            if(data){
                if(data['NSP_STATUS']){// 为零代码成功
                    return data.NSP_STATUS;
                }else if(data['errorCode']){// 为零代码成功
                    return data['errorCode'];
                }else {
                    return false;
                }
            }else {
                return false;// 如果data直接就是用，那直接提示系统错误
            }
        }

            /**
             * 默认的获取错误码的方法，直接拿NSP_STATUS, errorCode
             * @param api 接口名
             * @param handle 自己处理的错误码或自定义的返回处理
             * @return boolean
             */
        function myCustem(api,timeout) {
                return function (options, isCustomError) {
                    var defer = $q.defer();
                    BI(api, options);
                    AJAX(options,isCustomError,api,timeout).then(function (data) {
                        defer.resolve(data);
                    }).catch(function (data) {
                        //直接返回错误码
                        defer.reject(getErrorCodeFunction(data));
                    });
                    return defer.promise;
                };
            }

           function errMyCustem(api,timeout) {
               return function (options, isCustomError) {
                   var defer = $q.defer();
                   BI(api, options);
                   errorAjax(options,isCustomError,api,timeout).then(function (data) {
                       defer.resolve(data);
                   }).catch(function (data) {
                       //直接返回错误码
                       defer.reject(getErrorCodeFunction(data));
                   });
                   return defer.promise;
               };
           }

            return {
                getSettlement: myCustem('OpenTrade.Server4User.getSettlement'),
                getAttachment: myCustem('OpenTrade.Server4User.getAttachment'),
                getEdmAttachment: myCustem('OpenTrade.Server4User.getEdmAttachment',300000),
                confirmSettlement: myCustem('OpenTrade.Server4User.confirmSettlement'),
                createDispute: myCustem('OpenTrade.Server4User.createDispute'),
                getOrderList:myCustem('OpenTrade.Server4User.getOrderList'),
                cancelOrder:myCustem('OpenTrade.Server4User.cancelOrder'),
                getOrderDetail: myCustem('OpenTrade.Server4User.getOrderDetail'),
                createOrder: myCustem('OpenTrade.Server4User.createOrder'),
                transfer:myCustem('OpenTrade.Server4User.transfer'),
                uploadCertificate:myCustem('OpenTrade.Server4User.uploadCertificate'),
                getBalance:myCustem('OpenTrade.Server4User.queryBalance'),
                updateOrderReceipt:myCustem('OpenTrade.Server4User.updateOrderReceipt'),
                getGiftBalanceDetails:myCustem('OpenTrade.Server4User.queryGiftBalanceDetails'),
                getDispute:myCustem('OpenTrade.Server4User.getDispute'),
                cancelDispute:myCustem('OpenTrade.Server4User.cancelDispute'),
                exportPurchaseContract: myCustem('OpenTrade.Server4User.exportPurchaseContract'),
                queryUserBalRemindInfo: myCustem('OpenTrade.Server4User.queryUserBalRemindInfo'),
                modUserBalRemindInfo: myCustem('OpenTrade.Server4User.modUserBalRemindInfo'),
                getDetailSettlement: myCustem('OpenTrade.Server4User.getDetailSettlement'),
                getDetailAttachment: myCustem('OpenTrade.Server4User.getDetailAttachment'),
                getHistorySettlement: myCustem('OpenTrade.Server4User.getHistorySettlement'),
                getEduOrderDetail: myCustem('OpenTrade.Server4User.getEduOrderDetail',300000),
                createRefundOrder:errMyCustem('OpenTrade.Server4User.createRefundOrder'),
                getRefundDetailList:myCustem('OpenTrade.Server4User.getRefundDetailList'),
                revokeRefundOrder:myCustem('OpenTrade.Server4User.revokeRefundOrder'),
                checkOrderConsumeStatus: errMyCustem('OpenTrade.Server4User.checkOrderConsumeStatus'),
                getInvalidOrderDetail: myCustem('OpenTrade.Server4User.getInvalidOrderDetail'),
                //OpenTrade.Server4User.getCashierUrl  在线支付接口
                getCashierUrl:myCustem('OpenTrade.Server4User.getCashierUrl'),
                sendIAPInvoiceMail:myCustem('OpenTrade.Server4User.sendIAPInvoiceMail'),
            };
        }]);
});

